import { Resolve } from '@angular/router'
import { Injectable } from '@angular/core'
import { EnvironmentService } from 'framework/environment/environment.service'

@Injectable()
export class ModelIdResolver implements Resolve<string> {
    constructor(private environmentService: EnvironmentService) {}

    resolve(): string {
        return this.environmentService.environment['modelId']
    }
}
